import axios from 'axios';
import { mutate } from 'swr';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';

import { TStatesAndZips } from '../../interfaces';

export const requestUpdateIcsAndExcs = (lenderId: string, data: Partial<TStatesAndZips>) => {
  const path = `/${SERVICES.LENDER}/lenders/${lenderId}/statesAndZips`;

  return mutate(`/${SERVICES.LENDER}/lenders/${lenderId}`, async () => {
    try {
      await axios.patch(path, data);
      Notistack.successMessage('Incs and Excs - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
